module.exports = __webpack_public_path__ + "static/logo-white-2e5e73219cb4639a5b329aaffbd33504.svg";